<template>
	<div class="listmore">
		<div class="search_resu">
			<div class="result_title">
				<div class="result_title_flex">
					作者主贴
				</div>
			</div>
			<div class="result_box">
				<div class="result_box_title">
					<div class="result_left">帖子</div>
					<div class="result_right">评论数</div>
				</div>
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
					<van-list
					v-model="loading"
					:finished="finished"
					finished-text="已加载全部"
					@load="onLoad"
					>
					
					<div v-for="(item, index) in list" :key="'list_' + item.id" :class="index%2==1?'result_text':'result_text result_text_active'" @click="goBbs(item.id)">
						<div class="result_left van-ellipsis" style="text-decoration:underline;">
							{{item.name}}
							<img class="result_title_bage" v-if="item.label_two.type==2" :src="img.new">
							<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='1级'" :src="img.level1">
							<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='2级'" :src="img.level2">
							<img class="result_title_bage" v-if="item.label.type==1&&item.label.name=='3级'" :src="img.level3">
							<img class="result_title_bage" v-if="item.label.type==3" :src="img.hot">
							<img class="result_title_bage" v-if="item.label.type==4" :src="img.vie">
						</div>
						<div class="result_right">{{item.comment_num}}</div>
					</div>
				</van-list>
			</van-pull-refresh>
		</div>
	</div>
	<van-popup v-model="showPicker" position="bottom">
		<van-datetime-picker
		v-model="currentDate"
		type="date"
		@confirm="onConfirm"
		@cancel="showPicker = false"
		:max-date="maxDate"
		/>
	</van-popup>
</div>
</template>

<script>
	import admin from '../../api/admin';
	import { mapState } from 'vuex';
	import { Col, Row,Search,Cell,Toast,DatetimePicker,Field,Popup,Button,Icon,List,PullRefresh } from 'vant';
	export default {
		data () {
			return {
				btn_type:1,
				list:[],
				maxDate:new Date(),
				currentDate: new Date(),
				showPicker:false,
				end_time:'',
				start_time:'',
				loading: false,
				finished: false,
				isLoading:false,
				params:{
					page:1,
					user_id:0
				},
				img:{
					hot:require('../../assets/img/hot.png'),
					new: require('../../assets/img/new.png'),
					level1: require('../../assets/img/level1.png'),
					level2: require('../../assets/img/level2.png'),
					level3: require('../../assets/img/level3.png'),
					vie:require('../../assets/img/vie.png')
				}
			}
		},
		computed: {
			...mapState({
				user: state => state.param.user
			})
		},
		
		created () {
			var myDate = new Date(); //获取系统当前时间
			var date1 = new Date(myDate.getTime()).toLocaleDateString();
			var date2 = new Date(myDate.getTime() - (7 * 24 * 60 * 60 * 1000)).toLocaleDateString();
			var date3 = new Date(myDate.getTime() - (30 * 24 * 60 * 60 * 1000)).toLocaleDateString();
			this.end_time=date1.replace(/\//g,'-')
			this.severTime=date2.replace(/\//g,'-')
			this.thereTime=date3.replace(/\//g,'-')
			if(localStorage.getItem('moreuserid')){
				this.params.user_id = localStorage.getItem('moreuserid')
				localStorage.removeItem('moreuserid')
			}
		},
		methods: {
			goBbs(id){
				localStorage.setItem('bbsid', id)
				wx.miniProgram.navigateTo({url:'/pages/webview/webview?scene=bbsinfo'})
			},
			chooseBtn(type){
				this.btn_type=type
				if(type!=3){
					this.getBbsMore()
				}else{
					this.start_time=''
					this.end_time=''
				}
				
			},
			searchBtn(){

				this.getBbsMore()
			},
			showPickerd(num){
				this.timeField=num
				this.showPicker=true
			},
			onConfirm(time) {
				var Y = time.getFullYear();
				var M = time.getMonth() + 1;
				M = M < 10 ? '0' + M : M;
				var D = time.getDate();
				D = D < 10 ? '0' + D : D;
				var H = time.getHours();
				H = H < 10 ? '0' + H : H;
				var Mi = time.getMinutes();
				Mi = Mi < 10 ? '0' + Mi : Mi;
				var S = time.getSeconds();
				S = S < 10 ? '0' + S : S;

				this.showPickertime = false;
				if(this.timeField==1){
					this.start_time=Y + '-' + M + '-' + D
				}else{
					this.end_time=Y + '-' + M + '-' + D
				}
				this.showPicker = false;
			},
			onRefresh() {
				this.isLoading = false;
				this.finished = false
				this.list=[]
				this.params.page = 1
				this.onLoad()
			},
			onLoad(){
				setTimeout(() => {
					if(this.btn_type==1){
						var start_time=this.severTime
					}else if(this.btn_type==2){
						var start_time=this.thereTime
					}else if(this.btn_type==3){
						var start_time=this.start_time
					}
					this.params.start_time=start_time
					this.params.end_time=this.end_time

					admin.getUserBbsMore(this.params).then(res => {
						if(res.data.state==1){
							this.list.push.apply(this.list, res.data.data.bbs_list)
							this.params.page += 1
							this.loading = false
							if(res.data.data.bbs_list.length <10){
								this.finished = true
								// if(res.data.data.length == 0) {
								// 	this.finished = true
								// }
							}
							
						}else{

						}

					})
				}, 500);
			}

		},
		components: {
			[Col.name]: Col,
			[Row.name]: Row,
			[Search.name]:Search,
			[Cell.name]:Cell,
			[Toast.name]:Toast,
			[DatetimePicker.name]:DatetimePicker,
			[Field.name]:Field,
			[Popup.name]:Popup,
			[Button.name]:Button,
			[Icon.name]:Icon,
			[PullRefresh.name]:PullRefresh,
			[List.name]: List,
		}
	}
</script>
<style lang="scss">
.listmore{
	padding: 15px;
	.result_title{
		font-size: 14px;
		margin-top: 15px;
		padding-bottom:10px;
		border-bottom: 1px solid #EEEEEE;
		
		.result_title_flex{
			display: flex;
			align-items:center;
			margin-top: 10px;
		}
		.result_top_time{
			border-radius:4px;
			border:1px solid #BBBBBB;
			display: flex;
			align-items:center;
			font-size: 10px;
			
			float: right;
			width: 200px;
			.time_left{
				flex: 1;
			}
			.van-field{
				margin: 0 5px;
				font-size: 10px;
			}
			.van-cell{
				padding:3px 5px;
				width: 50%;
				.van-field__control{
					text-align: center;
				}
			}
			.van-button{
				height: 36px;
				line-height: 0;
			}
			
		}
		.searchBtn{
			color: #fff;
			margin-left: 10px;
			padding:5px 10px;
			border-radius:4px;
			background-color:#333333;
		}
		.choose_btn{
			border:1px solid #666666;
			color: #666666;
			font-size: 10px;
			border-radius:4px;
			padding:3px 10px;
			margin-left: 5px;
		}
		.choose_btn_active{
			background-color:#BBBBBB;
		}
	}
	.search_resu{
		margin-top: 20px;
		.result_box{
			font-size: 12px;
			padding:10px;
			margin-top: 15px;
			border:1px solid #BBBBBB;
			border-radius:4px;
			.result_box_title{
				display: flex;
				align-items:center;
				border-bottom:1px solid #EEEEEE;
				padding:0 10px 10px 10px;
				margin-bottom: 10px;
			}
			.result_text{
				display: flex;
				align-items:center;
				padding:10px 10px;
			}
			.result_text_active{
				background-color:#F8F8F8;
			}
			.result_left{
				flex: 1;
			}
			.result_right{
				float: right;
			}
			.result_bbstit{
				color: #333333;
				font-size: 12px;
				text-decoration:underline;
				border-bottom:1px solid #EEEEEE;
				padding-bottom:10px;
			}
			.result_title_bage{
				width: 36px;
				height: 16px;
				vertical-align:middle;
				margin-left: 10px;
			}
			.result_bbstime{
				color: #999999;
				font-size: 12px;
				padding-top:10px;
				display: flex;
				align-items:center;
			}
		}
		.keyword_box{
			border: 1px solid #BBBBBB;
			border-radius: 4px;
			font-size:12px;
		}
	}
}

</style>